import styled from "styled-components/macro";
import { focusVisible, buttonReset } from "../../../../styles/a11y";

export const Container = styled.li`
  position: relative;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : "none")};
  width: auto;
  min-width: 0;

  &.toolbar-dropdown-open {
    z-index: 100000;
  }

  .hover-tip {
    display: none;
  }

  &:hover {
    .hover-tip {
      display: block;
    }
  }

  .item {
    background: var(--document-background);
    color: var(--grey-0);
    font-family: Inter;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    min-width: 0;
    max-width: 100%;
    border-radius: 20px;
    height: 40px;
    margin-right: 10px;
    line-height: 27px;
    position: relative;
    box-shadow: ${(props) => (props.isMenuCollapsed ? "none" : "0px 2px 6px rgba(0, 0, 0, 0.15)")};

    .open {
      ${buttonReset}
      ${focusVisible}
      color: var(--grey-0);
      font-family: Inter;
      font-weight: 500;
      font-size: 16px;
      line-height: 27px;
      padding: 0px 15px 0px 15px;
      position: relative;
      display: flex;
      align-items: center;
      height: 100%;
      border-radius: 20px;
      background: var(--document-background);
      min-width: 0;
      max-width: 100%;
      overflow: hidden;

      &.dropdown {
        border-radius: 20px 0 0 20px;
      }

      &:hover {
        background: var(--document-background-hover);
      }

      svg {
        min-width: 22px;
      }
    }

    &.disabled {
      opacity: 0.5;
    }

    p {
      opacity: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .tip {
      left: -15px;
    }

    img,
    svg {
      width: 22px;
      vertical-align: middle;
      margin-right: 9px;
      opacity: 1;

      path {
        fill: var(--grey-0);
        opacity: 1;
      }
    }

    /* &:hover {
      background: var(--document-background-hover);
    } */

    &:active {
      background: var(--document-background-active);
    }

    .chevron {
      ${buttonReset}
      ${focusVisible}
      color: var(--grey-0);
      background: var(--document-background);
      padding-right: 5px;
      height: 40px;
      display: flex;
      align-items: center;
      border-left: 2px solid var(--menu-color-hover);
      border-radius: 0px 20px 20px 0px;

      &:hover {
        background: var(--document-background-hover);
      }

      .arrow {
        padding-left: 10px;
        /* padding-top: 6px; */

        svg {
          path {
            fill: var(--grey-0);
          }

          width: 14px;
        }
      }
    }
  }
`;
